export interface ILang {
	[key: string]: {
		text: string;
		lng: 'en' | 'ar' | 'hi';
		icon: string;
	};
}

const LANG: ILang = {
	EN: {
		text: 'English',
		lng: 'en',
		icon: 'CustomUk',
	},
	AR: {
		text: 'Arabic',
		lng: 'ar',
		icon: 'CustomUae',
	},
	HI: {
		text: 'Hindi',
		lng: 'hi',
		icon: 'CustomIndia',
	},
};

export const getLangWithKey = (key: ILang['key']['lng']): ILang['key'] => {
	// @ts-ignore
	return LANG[Object.keys(LANG).filter((f) => key.includes(LANG[f].lng))];
};
export default LANG;
